"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateHistoryLabel = void 0;
exports.generateHistoryLabel = function (label, _a) {
    var isMobile = _a.isMobile;
    return label + " - updated" + (isMobile ? ' for a mobile mode' : '');
};
//# sourceMappingURL=generateHistoryLabel.js.map